jQuery(function($){
  
    updateCartStuff();
	
	resizeWindow();
	  		
 	$(window).resize(resizeWindow);
	 				
	// nav menu
    $('.menu_open').on('touchend click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        $('html, body').css({'overflow':'hidden'});
        $('#overlay').fadeIn(300);
        $('#menu_drawer').addClass('open');
    });
    $('.menu_close').on('touchend click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        $('#menu_drawer').removeClass('open');  
        $('#overlay').fadeOut(300);
        $('html, body').css({'overflow':'initial'});
    });
	
	// nav submenus
	$('#menu_drawer .menu.primary li a.arrow').on('touchend click', function(e) {
        e.stopPropagation();
        e.preventDefault();
		$(this).toggleClass('open');
		$(this).next('ul').slideToggle('fast');
	});
	
	// homepage nav
	$('#home li a').hover(function() {
		var rel = $(this).attr('rel');
		$('#home .bg.' + rel + '.active').stop().animate({
			opacity: 1
		}, 400);
	}, function() {
		var rel = $(this).attr('rel');		
		$('#home .bg.' + rel + '.active').stop().animate({
			opacity: 0
		}, 400, function() {
			var $next = $('#home .bg.' + rel + '.active').next('.bg.' + rel);
			if( $next.length == 0 ) { 
				$next = $('#home .bg.' + rel + ':first');
			}
			$('#home .bg.' + rel + '.active').removeClass('active');
			$next.addClass('active');
		});		
	});
	
	// portfolio filter
	$('.gallery .toggle_filters .toggler').on('touchend click', function(e) {
        e.stopPropagation();
      	e.preventDefault();
		$(this).toggleClass('open');
        $('.gallery .toggle_filters').toggleClass('open');
		$('.gallery .toggle_filters .filters ul').stop(true, false, true).slideToggle(300);
    });
		
	// gallery
	if ($('.gallery .grid').length) {
		var $grid = $('.gallery .grid').imagesLoaded(function() {
			$grid.masonry();
		});
		$('.gallery').Chocolat({
			loop: true,
			separator2: ' / ',
			afterImageLoad: function() {
				$('<span class="pagination">' + this.elems.pagination[0].innerText + '</span>').appendTo(this.elems.content);
				//$('<span class="heart empty" rel="' + this.elems.description[0].innerText + '"></span>').appendTo(this.elems.content);
			}
		});
	}
		
	// newsletter signup
	$(window).load(function(){
		if(typeof(Storage) !== "undefined") {
			if (localStorage.acShowPopup != 1) {
				setTimeout(function(){
					$('#newsletter').fadeIn(300);
				}, 0);
			} 				
		} 
	});
	if ($('.mailchimp').length) {
		$.validator.addMethod('defaultInvalid', function(value, element) {
		switch (element.value) {
			case 'Email Address':
				if (element.name == 'EMAIL') return false;
				break;
			default: return true; 
				break;
		}
	},$.validator.messages.required);
		$('.mailchimp').each(function() {
			var $this = $(this);						  
			$this.validate({
			debug: false,
			rules: {
				EMAIL: {
					required: true,
					email: true,
					defaultInvalid: true
				}
			}
			});
		});
	}	
    $('#newsletter .no-thanks').on('touchend click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      $('#newsletter').fadeOut(300, function() {
        localStorage.acShowPopup = 1; 
      });
    });
	$('#newsletter .close').on('touchend click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      $('#newsletter').fadeOut(300, function() {
        localStorage.acShowPopup = 1;									   
      });
	});
	
	// cart drawer open
    $('.view_cart').on('touchend click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      $('html, body').css({'overflow':'hidden'});
      $('#overlay').fadeIn(300);
      $('#cart_drawer').addClass('open');
      updateCartStuff();
    });
	
	// cart drawer close
    $('.cart_close').on('touchend click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      $('#cart_drawer').removeClass('open');  
      $('#overlay').fadeOut(300);
      $('html, body').css({'overflow':'initial'});
    });
	
	// print size
    $('#product .options .details .size').on('touchend click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      $('#product .options .details .size').removeClass('active');	
      $(this).addClass('active');
      var size = $(this).text();
      $('#product-select-option-0').val(size).trigger('change');
    });
	
	// product tabs
	if ($('#tabs').length) {
      $('#tabs .cell').on('touchend click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        $('#tabs .cell').removeClass('active');
        $(this).addClass('active');
        var rel = $(this).attr('rel');
        $('#tabs .tab').hide(0);
        $('#tabs .tab.tab_' + rel).fadeIn(300);
      });
	}
	
});

function resizeWindow() {

	var ww = $(window).width();
			
	if (ww > 768) {
			
		if ($('#home').length) {
			var wh = $(window).height();
			var hh = $('#header').outerHeight();
			var mh = $('#monogram').outerHeight();
			var total = wh - hh - mh;
			$('#home').css('height', total + 'px');
		}
		  
	}
			
}

function addItem(form_id) {
   $.ajax({
     type: 'POST', 
     url: '/cart/add.js',
     dataType: 'json', 
     data: $('#' + form_id).serialize(),
     error: function(obj, status) { 
       alert('The product you are trying to add is out of stock.');
     }
   })
   .done(function() {
     updateCartStuff();
     $('html, body').css({'overflow':'hidden'});
     $('#overlay').fadeIn(300);
     $('#cart_drawer').addClass('open'); 
   });
}

function cartSubtract(variant_id, qty) {
 
  var newQty = qty - 1;
  var data = 'updates[' + variant_id + ']=' + newQty;
  
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json'
  })
  .done(function() {
    updateCartStuff();
  });
  
}

function cartAdd(variant_id, qty) {
 
  var newQty = qty + 1;
  var data = 'updates[' + variant_id + ']=' + newQty;
  
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json'
  })
  .done(function() {
    updateCartStuff();
  });
  
}

function cartRemove(variant_id) {
 
  var data = 'updates[' + variant_id + ']=0';
  
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json'
  })
  .done(function(data) {
    updateCartStuff();
  });
  
}

function updateCartStuff() {
    
  $.ajax({
    
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) { 
        
        // console.log(cart);
        
        $('#cart_drawer .inner').html('');
        
        $('#cart_drawer .checkout .subtotal .total_price').html((Shopify.formatMoney(cart.total_price)).replace('.00',''));

        if (cart.item_count > 0) {
          
          $.each(cart.items, function(index, cartItem) {

            // console.log(cartItem);

            var item = '';
            
            item += '<div class="item item-' + cartItem.variant_id + '">';
              item += '<table cellpadding="0" cellspacing="0" border="0" width="100%">';
                item += '<tbody>';
                  item += '<tr>';
                    item += '<td class="image" rowspan="2"><a href="' + cartItem.url + '"><img src="' + cartItem.image + '" alt=""></a></td>';
                    item += '<td class="product kepler"><a href="' + cartItem.url + '">' + cartItem.product_title + '</a></td>';
                    item += '<td class="delete"><span onclick="cartSubtract(' + cartItem.variant_id + ', ' + cartItem.quantity + '); return false;"></span></td>';
                  item += '</tr>';
                  item += '<tr>';
                    item += '<td class="desc">';
            		  if (cartItem.variant_options.length > 0) {
                        $.each(cartItem.variant_options, function(i,o) {
                          if (o != 'Default Title') {
                            item += cartItem.options_with_values[i].name + ': ' + o + '<br>';;
                          }
                        });
                      }
                      if (cartItem.properties) {
                        $.each(cartItem.properties, function(i, o) {
                          if (o != '') {
                            item += i + ': ' + o + '<br>';
                          }
                        });
                      }
            		  item += 'Quantity: ' + cartItem.quantity;
            		item += '</td>';
                    item += '<td class="price">' + (Shopify.formatMoney(cartItem.price)).replace('.00','') + '</td>';
                  item += '</tr>';
                item += '</tbody>';
              item += '</table>';
            item += '</div>';
                                                  
            $('#cart_drawer .inner').append(item);       

          });
        
          $('#cart_drawer .checkout').show(0);
          
        } else {

          $('#cart_drawer .inner').append('<div class="empty centertext">Your cart is empty.</div>');

          $('#cart_drawer .checkout').hide(0);

        }
        
        $('#cart_drawer .cart_count, #header .cart a span').html(cart.item_count);
  
     }
               
  });
  
}